import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPracticeAssessments } from '../../store/actions/PracticeTestActions';
import PracticeTestAttemptsComponent from '../../components/PracticeTestAttempts/PracticeTestAttemptsComponent';

const PracticeTestAttemptsContainer = () => {
  const { testTitle, testId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { practiceAssessments, loading, error } = useSelector(state => state.practiceTest);

  // Decode the test title from URL
  const decodedTestTitle = decodeURIComponent(testTitle);

  useEffect(() => {
    dispatch(fetchPracticeAssessments(testId));
  }, [dispatch, testId]);

  const handleViewResults = assessmentId => {
    // Navigate to practice test result page
    history.push(`/practices-result/${assessmentId}`);
  };

  // Transform practice assessments to test attempts format
  const testAttempts =
    practiceAssessments?.results && Array.isArray(practiceAssessments.results)
      ? practiceAssessments.results.map((assessment, index) => ({
          id: assessment.id,
          test: `#${index + 1}`, // Serial number
          time: assessment.completion_time
            ? (() => {
                const duration =
                  new Date(assessment.completion_time) - new Date(assessment.start_time);
                const minutes = Math.floor(duration / (1000 * 60));
                const seconds = Math.floor((duration % (1000 * 60)) / 1000);
                return `${minutes}m ${seconds}s`;
              })()
            : '-',
          result: assessment.status === 'EV' ? 'Completed' : 'Not completed',
          score: assessment.score || 0,
        }))
      : [];

  return (
    <div style={{ backgroundColor: '#f0f3f7', width: '80%', margin: '30px auto' }}>
      <PracticeTestAttemptsComponent
        testAttempts={testAttempts}
        loading={loading}
        error={error}
        onViewResults={handleViewResults}
        testTitle={decodedTestTitle}
      />
    </div>
  );
};

export default PracticeTestAttemptsContainer;
